import React from 'react'
import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';

export const OnePersonCompany = () => {
    return (
        <div className='services_main_wrapper'>
            <div className='container'>
                <div className='row mt-5 mb-5'>
                    <div className='col-md-3'>
                        <LeftSideBar />
                    </div>
                    <div className='col-md-9'>
                        <div className='right_side_content'>
                            <div className='section_main_title d-flex align-items-center justify-content-between'>
                                <div className='title_and_icon d-flex align-items-center'>
                                    <img src='/images/opc_icon.jpg'></img>
                                    <Title text="One Person Company" className="custom-heading" />
                                </div>
                            </div>
                            <div className='discriptions'>
                                <p>A One Person Company (OPC) is a unique and innovative business structure introduced in India with the Companies Act, 2013. It allows a single individual to establish a company, combining the benefits of both a sole proprietorship and a corporate entity. At Vanani & Associates, we provide comprehensive services to help you establish and manage your OPC efficiently. Our expertise ensures that you can focus on growing your business while we handle the legal and compliance aspects.</p>
                                <h5>What is a One Person Company (OPC)?</h5>
                                <p>A One Person Company (OPC) is a company formed by a single individual, offering the advantages of limited liability and separate legal entity status. Before the implementation of the Companies Act, 2013, individuals could only form a sole proprietorship. The OPC structure provides a way for solo entrepreneurs to enjoy corporate benefits without needing multiple members.</p>
                            </div>
                            <div className="number_list_wrap key_eatures_opc">
                                <h4 className="section_title"><sapn className="key_features">Key Features</sapn> of OPC</h4>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ol className="feature_list">
                                            <li>
                                                <span className="feature_number">1</span>
                                                <div className="feature_content">
                                                    <strong>Limited Liability:</strong> The member's liability is limited to their shares, protecting personal assets from business liabilities.
                                                </div>
                                            </li>
                                            <li>
                                                <span className="feature_number">2</span>
                                                <div className="feature_content">
                                                    <strong>Separate Legal Entity:</strong> An OPC is a distinct legal entity from its member, offering greater credibility and legal standing.
                                                </div>
                                            </li>
                                            <li>
                                                <span className="feature_number">3</span>
                                                <div className="feature_content">
                                                    <strong>Easy Succession:</strong> The OPC continues to exist even after the member's demise, as the nominee takes over the company.
                                                </div>
                                            </li>
                                            <li>
                                                <span className="feature_number">4</span>
                                                <div className="feature_content">
                                                    <strong>Sole Directorship and Shareholder:</strong> A single member acts as both director and shareholder, managing day-to-day activities without needing additional directors.
                                                </div>
                                            </li>
                                            <li>
                                                <span className="feature_number">5</span>
                                                <div className="feature_content">
                                                    <strong>Ownership in Property:</strong> As a separate legal entity, an OPC can own property and assets in its name, ensuring the member’s personal assets are protected.
                                                </div>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                            <div className="op-comparison-wrapper">
                                <div className="op-card advantages">
                                    <div className="op-icon-head">👍</div>
                                    <div className="op-label">Advantages of One Person Company (OPC)</div>
                                    <ul>
                                        <li><i className="icon">✔</i><strong>Simple Incorporation:</strong> The OPC can be established with just one member and one nominee, with no minimum paid-up capital requirement.</li>
                                        <li><i className="icon">✔</i><strong>Less Compliance:</strong> OPCs are exempt from certain compliance requirements, simplifying administration.</li>
                                        <li><i className="icon">✔</i><strong>Efficient Management:</strong> Decision-making is swift and efficient as it involves only one person.</li>
                                        <li><i className="icon">✔</i><strong>Fundraising Capability:</strong> OPCs can easily raise money through venture capital, angel investors, and incubators.</li>
                                        <li><i className="icon">✔</i><strong>No Dividend Distribution Tax (DDT):</strong> OPCs are not subject to DDT if the sole shareholder does not draw dividends.</li>
                                    </ul>
                                </div>

                                <div className="op-card disadvantages">
                                    <div className="op-icon-head">👎</div>
                                    <div className="op-label">Disadvantages of One Person Company (OPC)</div>
                                    <ul>
                                        <li><i className="icon">✖</i><strong>Limited Growth Potential:</strong> OPCs are suitable for small businesses as they can only have one member.</li>
                                        <li><i className="icon">✖</i><strong>Restrictions on Business Activities:</strong> OPCs cannot engage in non-banking financial or charitable activities.</li>
                                        <li><i className="icon">✖</i><strong>No Clear Distinction:</strong> Single-member director model may lead to conflicts of interest.</li>
                                        <li><i className="icon">✖</i><strong>Conversion Requirements:</strong> Must convert to Pvt Ltd if capital ₹50L or turnover ₹2Cr.</li>
                                        <li><i className="icon">✖</i><strong>Higher Compliance Costs:</strong> Despite exemptions, OPCs still have regulatory costs.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="opc-documents-container row align-items-stretch">
                                <h4 className="mb-4">Documents Required for <sapn className="key_features">OPC Registration</sapn></h4>
                                <div className="col-md-6 mb-4">
                                    <div className="opc-card">
                                        <div className="opc-header">
                                            <h4>📁 Director's Documents</h4>
                                        </div>
                                        <ul className="opc-list">
                                            <li><span>📷</span> Passport-sized photograph</li>
                                            <li><span>🪪</span> PAN card (self-attested)</li>
                                            <li><span>🧾</span> Identity proof (Aadhaar/Voter ID/Passport/DL)</li>
                                            <li><span>🏡</span> Residential address proof</li>
                                            <li><span>🏦</span> Bank statement</li>
                                        </ul>
                                    </div>

                                    <div className="opc-card mt-4">
                                        <div className="opc-header">
                                            <h4>🏢 Business Address Proof</h4>
                                        </div>
                                        <ul className="opc-list">
                                            <li><span>💡</span> Latest electricity bill</li>
                                            <li><span>📝</span> Rent agreement (if rented)</li>
                                            <li><span>📄</span> NOC from property owner</li>
                                            <li><span>📜</span> Sale deed (if owned)</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="opc-card">
                                        <div className="opc-image">
                                            <img src="/images/opc_bnr.jpg" alt="OPC Registration Image" />
                                        </div>
                                    </div>

                                    <div className="opc-card mt-4">
                                        <div className="opc-header">
                                            <h4>📌 Additional Details</h4>
                                        </div>
                                        <ul className="opc-list">
                                            <li><span>📱</span> Mobile number</li>
                                            <li><span>📧</span> Email ID</li>
                                            <li><span>🏷️</span> Proposed company name</li>
                                            <li><span>📦</span> Description of products/services</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="opc_steps_timeline">
                                <h4 className="mb-4">Steps for OPC <sapn className="key_features">Registration</sapn></h4>
                                <div className="step-row">
                                    <div className="step-box">
                                        <span className="step-number">1</span>
                                        <h5>Check Eligibility and Documentation</h5>
                                        <p>Ensure that you meet the eligibility criteria and have all the required documents.</p>
                                    </div>
                                    <div className="step-box">
                                        <span className="step-number">2</span>
                                        <h5>Obtain DSC and DIN</h5>
                                        <p>Secure a Digital Signature Certificate (DSC) and Director Identification Number (DIN) for the proposed director.</p>
                                    </div>
                                    <div className="step-box">
                                        <span className="step-number">3</span>
                                        <h5>Name Reservation</h5>
                                        <p>Apply for name reservation through the MCA portal using Form SPICe+ (Part A).</p>
                                    </div>
                                    <div className="step-box">
                                        <span className="step-number">4</span>
                                        <h5>Prepare MOA and AOA</h5>
                                        <p>Draft the Memorandum of Association (MOA) and Articles of Association (AOA).</p>
                                    </div>
                                    <div className="step-box">
                                        <span className="step-number">5</span>
                                        <h5>File Incorporation Forms</h5>
                                        <p>Submit the SPICe+ form along with MOA, AOA, and other required documents to the MCA.</p>
                                    </div>
                                    <div className="step-box">
                                        <span className="step-number">6</span>
                                        <h5>Certificate of Incorporation</h5>
                                        <p>Upon approval, the MCA issues a Certificate of Incorporation along with PAN and TAN for the company.</p>
                                    </div>
                                    <div className="step-box">
                                        <span className="step-number">7</span>
                                        <h5>Bank Account Opening</h5>
                                        <p>Open a bank account in the company's name and deposit the initial capital.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="opc-timeline-wrapper">
                                <h4 className="timeline-title">Compliances for a <sapn className="key_features">One Person Company</sapn></h4>
                                <div className="opc-timeline">
                                    <div className="timeline-step">
                                        <div className="timeline-icon">🕒</div>
                                        <div className="timeline-content">
                                            <h5>Appointment of First Auditor</h5>
                                            <p>Within 30 days of incorporation.</p>
                                        </div>
                                    </div>

                                    <div className="timeline-step">
                                        <div className="timeline-icon">📄</div>
                                        <div className="timeline-content">
                                            <h5>Issue of Share Certificate</h5>
                                            <p>Within 60 days of incorporation.</p>
                                        </div>
                                    </div>

                                    <div className="timeline-step">
                                        <div className="timeline-icon">💰</div>
                                        <div className="timeline-content">
                                            <h5>Stamp Duty Payment on Share Certificate</h5>
                                            <p>Within 30 days of certificate issue.</p>
                                        </div>
                                    </div>

                                    <div className="timeline-step">
                                        <div className="timeline-icon">📤</div>
                                        <div className="timeline-content">
                                            <h5>Filing of INC-20A (Declaration for Business Commencement)</h5>
                                            <p>Within 180 days of incorporation, before commencing business.</p>
                                        </div>
                                    </div>
                                    <div className="timeline-step">
                                        <div className="timeline-icon">📆</div>
                                        <div className="timeline-content">
                                            <h5>Annual Filings</h5>
                                            <p>Filing annual returns and financial statements with the MCA.</p>
                                        </div>
                                    </div>
                                    <div className="timeline-step">
                                        <div className="timeline-icon">🧾</div>
                                        <div className="timeline-content">
                                            <h5>Income Tax Filing</h5>
                                            <p>File the company’s income tax return using form ITR-6 each financial year.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OnePersonCompany;
